import { API_BASE } from "./base";

function getAuthHeaders() {
  const token = null;
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseJson(res) {
  const text = await res.text();
  if (!res.ok) {
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (err) {
    return text;
  }
}

export async function listAdminUsers() {
  const res = await fetch(`${API_BASE}/admin/users`, {
    headers: getAuthHeaders(),
  });
  return parseJson(res);
}

export async function updateAdminUser(userId, payload) {
  const res = await fetch(`${API_BASE}/admin/users/${userId}`, {
    method: "PATCH",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function updateAdminUserBusinesses(userId, business_ids) {
  const res = await fetch(`${API_BASE}/admin/users/${userId}/businesses`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ business_ids }),
  });
  return parseJson(res);
}

export async function resetAdminUserPassword(userId, new_password) {
  const res = await fetch(`${API_BASE}/admin/users/${userId}/password`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ new_password }),
  });
  return parseJson(res);
}

export async function listAdminBusinesses() {
  const res = await fetch(`${API_BASE}/admin/users/businesses`, {
    headers: getAuthHeaders(),
  });
  return parseJson(res);
}
